import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  ExemptionCertificateListResponse,
  ExemptionCertificateQueryParams,
} from './types';

// get all exemption certificates for a customer
export function getExemptionCertificates({
  corporation_id,
  customer_id,
  limit = 10,
  cursor,
}: ExemptionCertificateQueryParams) {
  const query = new URLSearchParams();

  query.append('corporation_id', corporation_id.toString());
  query.append('customer_id', customer_id);

  if (cursor) query.append('cursor', cursor);
  if (limit) query.append('limit', limit.toString());

  const { data, error, isLoading, mutate } =
    useSWR<ExemptionCertificateListResponse>(
      `new-sales-tax/exemption-certificates?${query}`,
      SWRFetcher(
        {
          method: 'GET',
        },
        undefined
      )
    );

  return {
    exemptionCertificates: data?.data.exemption_certificates ?? [],
    cursor: data?.data.cursor,
    totalExemptionCertificates: data?.data.total_exemption_certificates ?? 0,
    isLoading,
    error,
    mutate,
  };
}
